import React from "react";
import { Zap, Calendar } from "lucide-react";

export default function AnnouncementBar() {
  return (
    <div className="relative z-30 bg-[rgba(196,255,61,0.06)] border-b border-[rgba(196,255,61,0.18)]">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs md:text-sm">
        <span className="inline-flex items-center gap-1.5 text-[#C4FF3D] font-bold uppercase tracking-wider">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#C4FF3D] opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#C4FF3D]" />
          </span>
          Live Workshop
        </span>
        <span className="text-white/50 hidden sm:inline">|</span>
        <span className="inline-flex items-center gap-1.5 text-white/85">
          <Calendar className="w-3.5 h-3.5 text-[#C4FF3D]" />
          <span className="font-semibold">Sun, 26 July · 11:00 AM IST</span>
        </span>
        <span className="text-white/50 hidden sm:inline">|</span>
        <span className="inline-flex items-center gap-1.5 text-white">
          <Zap className="w-3.5 h-3.5 text-[#C4FF3D]" fill="#C4FF3D" />
          <span className="font-semibold">Register for ₹199</span>
          <span className="text-white/50 hidden md:inline">· Limited access</span>
        </span>
      </div>
    </div>
  );
}
